import UserApi from "../api/UserAdminApi";

export default {
  createUser: async (values) => {
    const normalize = (value) =>
      typeof value === "string" ? value.trim() : "";

    const upper = (value) => normalize(value).toUpperCase();
    const lower = (value) => normalize(value).toLowerCase();

    const payload = {
      ...values,
      nombre: upper(values.nombre),
      primer_apellido: upper(values.primer_apellido),
      segundo_apellido: upper(values.segundo_apellido),
      correo_institucional: lower(values.correo_institucional)
    };

    const response = await UserApi.createUser(payload);
    return response;
  },
  getUsers: async (FiltersUser) => {
    const response = await UserApi.getUsers(FiltersUser);
    return response;
  },
  updateUser: async (values) => {
    const response = await UserApi.updateUser(values);
    return response;
  },
};